<form class="border-bottom p-4" *ngIf="bankAccountForm" [formGroup]="bankAccountForm">
    <div class="row justify-content-between">
      <div class="alert alert-danger px-0" role="alert">
        <ol class="fw-bold mb-0">
          <li> {{ 'Sellers.Products.BankWarning01' | translate }}</li>
          <li> {{ 'Sellers.Products.BankWarning02' | translate }}</li>
          <li> {{ 'Sellers.Products.BankWarning03' | translate }}</li>
        </ol>
      </div>
      <div class="col-md-12 mb-3">
        <label>{{ 'Sellers.Products.AccountType' | translate }} <span class="text-danger">*</span></label>
        <select formControlName="bank_type"
                class="form-control form-select"
                (change)="onBankTypeSelection($event)"
                required>
          <option selected disabled [value]="null">{{ 'Sellers.Products.SelectِAccountType' | translate }}</option>
          <option *ngFor="let type of accountTypesTranslated | keyvalue" [value]="type.value.value">
            {{ type.value.name  | translate }}
          </option>
        </select>
        <small *ngIf="formValidator?.formErrors?.bank_id"
               class="text-danger">
          {{ formValidator.formErrors.bank_id }}
        </small>
      </div>
      
      <div class="col-md-6 mb-3" *ngIf="isBank">
        <label>{{ 'Sellers.Products.BankName' | translate }} <span class="text-danger">*</span></label>
        <select formControlName="bank_id"
                class="form-control form-select"
                (change)="onBankSelection($event)"
                required>
          <option selected disabled [value]="null">{{ 'Sellers.Products.SelectBankName' | translate }}</option>
          <option *ngFor="let bank of banks" [value]="bank.id">
            {{ bank.bank_name }}
          </option>
        </select>
        <small *ngIf="formValidator?.formErrors?.bank_id"
               class="text-danger">
          {{ formValidator.formErrors.bank_id }}
        </small>
      </div>

      <div class="col-md-6 mb-3" *ngIf="isBank">
        <label>{{ 'Sellers.Products.BranchName' | translate }} <span class="text-danger">*</span></label>
        <select formControlName="BranchId"
                class="form-control form-select"
                required>
          <option selected disabled value="null">{{ 'Sellers.Products.SelectBranchName' | translate }}</option>
          <option *ngFor="let bankBranch of bankBranches"
                  [value]="bankBranch.id">
            {{ bankBranch.english_branch_name }}
          </option>
        </select>
        <small *ngIf="formValidator?.formErrors?.BranchId"
               class="text-danger">
          {{ formValidator.formErrors.BranchId }}
        </small>
      </div>

      <div class="col-md-6 mb-3">
        <label>{{ (isBank ? 'Sellers.Products.AccountHolderName' : 'Sellers.Products.MobileWalletHolderName') | translate }} <span class="text-danger">*</span></label>
        <input class="form-control"
               type="text"
               formControlName="holder_name"
               required
               placeholder="{{ (isBank ? 'Sellers.Products.AccountHolderName' : 'Sellers.Products.MobileWalletHolderName') | translate }}" />
        <small *ngIf="formValidator?.formErrors?.holder_name"
               class="text-danger">
          {{ formValidator.formErrors.holder_name }}
        </small>
      </div>

      <div class="col-md-6 mb-3">
        <label>{{ ( isBank ? 'Sellers.Products.AccountNumber' : 'Sellers.Products.MobileWalletNumber') | translate }} <span class="text-danger">*</span></label>
        <input class="form-control" type="text" required 
               placeholder="{{ ( isBank ? 'Sellers.Products.AccountNumber' : 'Sellers.Products.MobileWalletNumber') | translate }}"
               formControlName="account_number"/>
        <small *ngIf="formValidator?.formErrors?.account_number"
               class="text-danger">
          {{ formValidator.formErrors.account_number }}
        </small>
      </div>

      <div class="col-auto">
        <button (click)="bankAccountForm.reset()"
                class="btn btn-outline-danger"
                [disabled]="formValidator.isEmpty() || buttonsDisabled">
          {{ 'Sellers.Products.Cancel' | translate }}
        </button>
      </div>
      <div class="col-auto">
        <button type="submit"
                class="btn btn-primary"
                (click)="AddBankAccount()"
                [disabled]="bankAccountForm.invalid || buttonsDisabled">
          {{ 'Sellers.Products.Add' | translate }}
        </button>
      </div>
    </div>
  </form>